document.addEventListener( 'DOMContentLoaded', function () {
	var body = document.body;

	const addClassToBody = () => {
		if ( window.scrollY ) {
			body.classList.add( 'fixed' );
		} else {
			body.classList.remove( 'fixed' );
		}
	};

	// if ( jQ( 'body.single-post, body.category' ).length <= 0 ) {
	// 	addClassToBody();
	// }
	document
		.querySelectorAll( 'p, h1, h2, h3, h4, h5, h6, a' )
		.forEach( function ( element ) {
			element.setAttribute( 'tabindex', '0' );
		} );

	const addClassToBodyOnScroll = () => {
		document.addEventListener(
			'scroll',
			() => {
				addClassToBody();
			},
			{ passive: true }
		);
	};

	// if (
	// 	jQ(
	// 		'body.single-post, body.category, body.single-tribe_events, body.single-envira_album, body.single-envira, body.post-type-archive-tribe_events, body.error404, body.page-template-no-banner, body.search-results'
	// 	).length <= 0
	// ) {
	addClassToBodyOnScroll();
	// }

	if ( jQ( 'body.search-results' ).length >= 1 ) {
		document.addEventListener(
			'scroll',
			() => {
				if ( window.scrollY ) {
					body.classList.remove( 'fixed__menu' );
				} else {
					body.classList.add( 'fixed__menu' );
				}
			},
			{ passive: true }
		);
	}

	jQ( '#open-search, #open-search-mobile' ).click( function () {
		jQ( this ).toggleClass( 'close-search' );
		jQ( '.header__section-search' ).slideToggle( '400' );
		setTimeout( function () {
			jQ( '#searchInput' ).focus();
		}, 500 );
	} );
} );
